import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { FIKAMI, mailLink, waLink } from "../constants";

export const Footer = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/5 pt-16 pb-10 bg-[#0a0a0d]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            {/* FIKAMI LOGO — SVG asset at /fikami-logo.svg */}
            <img
              src="/fikami-logo.svg"
              alt="FIKAMI"
              className="h-12 sm:h-14 w-auto object-contain select-none"
              style={{ width: "auto" }}
              draggable={false}
            />
            <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase text-zinc-500 mb-4">
              {t.footer.links}
            </div>
            <ul className="space-y-2.5 text-sm text-zinc-300">
              <li>
                <button
                  data-testid="footer-link-services"
                  onClick={() => scrollTo("services")}
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  {t.nav.services}
                </button>
              </li>
              <li>
                <Link
                  data-testid="footer-link-products"
                  to="/productos"
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  {t.nav.products || "Products"}
                </Link>
              </li>
              <li>
                <button
                  data-testid="footer-link-workflows"
                  onClick={() => scrollTo("workflow")}
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  {t.nav.workflows}
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-link-solutions"
                  onClick={() => scrollTo("why")}
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  {t.nav.solutions}
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-link-contact"
                  onClick={() => scrollTo("contact")}
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  {t.nav.contact}
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.28em] uppercase text-zinc-500 mb-4">
              {t.footer.contact}
            </div>
            <ul className="space-y-2.5 text-sm text-zinc-300">
              <li>
                <a
                  data-testid="footer-email"
                  href={mailLink("New inquiry from fikamillc.com")}
                  className="inline-flex items-center gap-2 hover:text-[#FF5A00] transition-colors"
                >
                  <i className="fa-solid fa-envelope text-[#FF5A00] text-xs" />
                  {FIKAMI.email}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-whatsapp"
                  href={waLink(t.contact.waMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#FF5A00] transition-colors"
                >
                  <i className="fa-brands fa-whatsapp text-[#FF5A00] text-xs" />
                  {FIKAMI.whatsappNumber}
                </a>
              </li>
              <li className="pt-3 mt-1 border-t border-white/5">
                <span className="text-[11px] tracking-[0.28em] uppercase text-zinc-500">
                  {t.footer.legal}
                </span>
              </li>
              <li>
                <Link
                  data-testid="footer-privacy"
                  to="/privacy-policy"
                  className="hover:text-[#FF5A00] transition-colors"
                >
                  {t.footer.privacy}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <span>
            © {new Date().getFullYear()} {FIKAMI.brandFull}. {t.footer.rights}
          </span>
          <span className="tracking-[0.25em] uppercase">MX · US · CA</span>
        </div>
      </div>
    </footer>
  );
};
